import { useEffect, useState } from "react";
import { waitlistAPI } from "../../lib/api";
import { Clock, Filter, CheckCircle, Phone, Mail } from "lucide-react";
import { toast } from "sonner";
import { Header } from '../../components/layout/Header';

const SEGMENTOS = [
    { value: "", label: "Todos" },
    { value: "mulheres_com_proposito", label: "Mulheres c/ Propósito" },
    { value: "mesa_de_ester",          label: "Mesa de Ester" },
    { value: "luto_ao_recomeco",       label: "Do Luto ao Recomeço" },
    { value: "devocional",             label: "Devocional" },
    { value: "musica",                 label: "Música" },
    { value: "livro",                  label: "Livro" },
];

const STATUS_COLORS = {
    aguardando: "bg-yellow-900/30 text-yellow-300 border-yellow-700",
    contatado:  "bg-blue-900/30 text-blue-300 border-blue-700",
    convertido: "bg-green-900/30 text-green-300 border-green-700",
};

export default function WaitlistAdmin() {
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [segmento, setSegmento] = useState("");

    const load = async () => {
        setLoading(true);
        try {
            const params = segmento ? { segmento } : {};
            const r = await waitlistAPI.list(params);
            setEntries(r.data || []);
        } catch { toast.error("Erro ao carregar lista de espera"); }
        finally { setLoading(false); }
    };

    useEffect(() => { load(); }, [segmento]);

    const updateStatus = async (id, status) => {
        try { await waitlistAPI.updateStatus(id, status); toast.success("Status atualizado"); load(); }
        catch { toast.error("Erro ao atualizar"); }
    };

    return (
        <>
        <Header title="Lista de Espera" subtitle={`${entries.length} pessoas aguardando`} actions={<select value={segmento} onChange={e => setSegmento(e.target.value)} className="bg-stone-900 border border-stone-800 rounded-lg px-3 py-2 text-sm text-stone-300 focus:outline-none focus:border-amber-600">{SEGMENTOS.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}</select>} />
        <div className="p-6 space-y-5">

            {loading ? (
                <div className="text-stone-500 text-sm text-center py-16">Carregando...</div>
            ) : entries.length === 0 ? (
                <div className="bg-stone-900 border border-stone-800 rounded-xl p-12 text-center">
                    <Clock className="w-10 h-10 text-stone-700 mx-auto mb-3" />
                    <p className="text-stone-400 text-sm">Lista de espera vazia.</p>
                </div>
            ) : (
                <div className="bg-stone-900 border border-stone-800 rounded-xl overflow-hidden">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b border-stone-800">
                                <th className="text-left px-4 py-3 text-xs text-stone-500 font-medium">Nome</th>
                                <th className="text-left px-4 py-3 text-xs text-stone-500 font-medium">Jornada</th>
                                <th className="text-left px-4 py-3 text-xs text-stone-500 font-medium">Contato</th>
                                <th className="text-left px-4 py-3 text-xs text-stone-500 font-medium">Mensagem</th>
                                <th className="text-left px-4 py-3 text-xs text-stone-500 font-medium">Status</th>
                                <th className="px-4 py-3" />
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-stone-800/50">
                            {entries.map(e => (
                                <tr key={e.id} className="hover:bg-stone-800/30 transition-colors">
                                    <td className="px-4 py-3 font-medium text-stone-200">{e.name}</td>
                                    <td className="px-4 py-3 text-xs text-stone-400">
                                        {SEGMENTOS.find(s => s.value === e.segmento)?.label || e.segmento}
                                    </td>
                                    <td className="px-4 py-3">
                                        <div className="space-y-0.5">
                                            {e.email && <div className="flex items-center gap-1 text-xs text-stone-400"><Mail className="w-3 h-3" />{e.email}</div>}
                                            {e.phone && <div className="flex items-center gap-1 text-xs text-stone-400"><Phone className="w-3 h-3" />{e.phone}</div>}
                                        </div>
                                    </td>
                                    <td className="px-4 py-3 text-xs text-stone-500 max-w-[200px] truncate">{e.message || "—"}</td>
                                    <td className="px-4 py-3">
                                        <span className={`text-xs px-2 py-0.5 rounded-full border ${STATUS_COLORS[e.status] || STATUS_COLORS.aguardando}`}>
                                            {e.status}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3">
                                        <select value={e.status}
                                            onChange={ev => updateStatus(e.id, ev.target.value)}
                                            className="bg-stone-800 border border-stone-700 rounded-lg px-2 py-1 text-xs text-stone-300 focus:outline-none">
                                            <option value="aguardando">Aguardando</option>
                                            <option value="contatado">Contatado</option>
                                            <option value="convertido">Convertido</option>
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
        </>
    );
}
